export default class AbstractAuthenticationProvider {
	constructor() {
		this.isReady = false;
		this.readyListener = null;
		this.onStateChange = null;
	}

	get onReady() {
		return this.readyListener;
	}

	set onReady(onReady) {
		this.readyListener = onReady;

		if (onReady && this.isReady) {
			setTimeout(() => {
				if (this.readyListener === onReady) {
					onReady();
				}
			}, 0);
		}
	}

	isSignedIn() {
		return false;
	}

	getAuthorizationToken() {}
}
